// Work List
export const WORK_LIST_ID = "1p5V0NNEhIoZedN0PVNirR";

// Media queries
export const PALM = "(max-width: 480px)";
export const BELOW_TABLET = "(max-width: 767px)";
export const TABLET_PORTRAIT = "(max-width: 768px)";
export const MID_TABLET = "(max-width: 896px)";
export const TABLET_LANDSCAPE = "(max-width: 1024px)";
